import { getPath } from '@/router/common'

const baseUrl = {
  title: '打印故障',
  path: 'printProblem'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'printProblem_Index',
    component: () => import(/* webpackChunkName: "printProblem_Index" */ '@/views/printProblem/index/index.vue'),
    meta: {
      title: '打印故障'
    }
  }
]
